import Vue from 'vue';
import state from '../state';

const getMultiplier = exp => Math.pow(10, exp);

export default {
  async loadAll() {
    const currencies = (await Vue.http.get('/api/currencies')).data;
    state.currencies.set(currencies);
  },
  format(sourceAmount, currencyId) {
    const currency = state.currencies.getCurrency(currencyId);
    const locale = navigator.language || navigator.userLanguage;
    const amount = sourceAmount / getMultiplier(currency.decimals);
    const amountStr = amount.toLocaleString(locale, { minimumFractionDigits: currency.decimals });
    return currency.symbol.length === 1 ? `${currency.symbol}${amountStr}` : `${amountStr} ${currency.symbol}`;
  },
  fromSource(amount, currencyId) {
    const currency = state.currencies.getCurrency(currencyId);
    return amount / getMultiplier(currency.decimals);
  },
  toSource(amount, currencyId) {
    const currency = state.currencies.getCurrency(currencyId);
    return parseInt(amount * getMultiplier(currency.decimals));
  },
  formatInvariant(sourceAmount, currencyId) {
    const currency = state.currencies.getCurrency(currencyId);
    const amount = sourceAmount / getMultiplier(currency.decimals);
    return amount.toFixed(currency.decimals);
  },
  getMinimal(currencyId) {
    const currency = state.currencies.getCurrency(currencyId);
    const amount = 1 / getMultiplier(currency.decimals);
    return amount.toFixed(currency.decimals);
  },
  async create(currency) {
    return (await Vue.http.post('/api/currencies', currency)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/currency.service.js